import React, { useState } from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import Theme from '../ui/Theme';
const useStyles = makeStyles(() => ({
  exitBtn: {
    width: '150px',
    height: '48px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    background: '#622FEE',
    color: '#FFFFFF',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  cancelBtn: {
    width: '150px',
    height: '48px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  contentTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: 'black',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  contentSubTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    /* identical to box height */
    display: 'flex',
    justifyContent: 'center',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: '8px',
  },

  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));
const ConfirmPopup = (props) => {
  const classes = useStyles();

  const [viewConfirm, setViewConfirm] = useState(props.open);

  const closePopup = () => {
    setViewConfirm(false);
    props.close();
  };

  return (
    <Modal
      isOpen={viewConfirm}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          position: 'relative',
          left: '50%',
          transform: 'translate(-50%,50%)',
          width: '348px',
          height: '213px',
          background: '#FFFFFF',
        },
      }}
    >
      <Grid container direction="column" justifyContent="space-between" alignItems="space-between">
        <Grid item>
          <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
            <Grid item>
              <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
                <Grid item className={classes.contentTitle}>
                  Are you sure you want to exit?
                </Grid>
                <Grid item className={classes.contentSubTitle}>
                  Unsaved changes will be lost.
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Button variant="contained" disableElevation className={classes.cancelBtn} onClick={closePopup}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" className={classes.exitBtn} onClick={props.closeJourneyPopup}>
                Exit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ConfirmPopup;
